// extracted by mini-css-extract-plugin
export default {"link":"KJ-z","disabled":"LJ-z"};